


import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getAllSettlementsAPI,
    updateSettlementStatusAPI,
    getSettlementProfitsAPI,
} from "../../../Servicefile/AccountManagementService.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================

const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" />
        </svg>
    ),
    Export: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Filter: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Bank: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="6" width="20" height="14" rx="2" />
            <path d="M2 10h20" />
            <path d="M8 14v4" />
            <path d="M12 14v4" />
            <path d="M16 14v4" />
        </svg>
    ),
    Status: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Close: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Edit: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6" />
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
        </svg>
    ),
    Settlement: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    TrendingUp: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
        </svg>
    ),
    TrendingDown: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
            <polyline points="17 18 23 18 23 12" />
        </svg>
    ),
    Wallet: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
            <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
    ),
    CheckCircle: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Clock: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ffc107" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    Building: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
            <line x1="9" y1="22" x2="15" y2="22" />
            <line x1="9" y1="6" x2="15" y2="6" />
            <line x1="9" y1="10" x2="15" y2="10" />
            <line x1="9" y1="14" x2="15" y2="14" />
        </svg>
    ),
    User: () => (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    settlementContainer: {
        padding: '11px 5px',
        width: '100%',
        maxWidth: '100%',
        scrollbarWidth: "none",
        overflowX: 'auto'
    },
    settlementHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    settlementTitle: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementTitleBadge: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    settlementStatsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '14px',
        padding: '15px',
        background: 'white',
        borderRadius: '14px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    settlementStatCard: {
        textAlign: 'center',
        borderRadius: '10px',
        transition: 'all 0.3s ease',
        cursor: 'default'
    },
    settlementStatValue: {
        fontSize: '16px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    settlementStatLabel: {
        fontSize: '12px',
        color: '#718096',
        fontWeight: '500',
        textTransform: 'uppercase',
        letterSpacing: '0.4px',
        marginTop: '4px'
    },
    settlementFilters: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 0',

    },
    settlementSearchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    settlementSelect: {
        padding: '8px 12px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    settlementSearchInput: {
        flex: '1',
        padding: '8px 14px 8px 38px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '180px'
    },
    settlementDateInput: {
        padding: '8px 14px',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.3s ease',
        height: '42px',
        background: 'white',
        minWidth: '150px'
    },
    settlementButton: {
        padding: '8px 18px',
        borderRadius: '10px',
        border: 'none',
        fontWeight: '600',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        height: '42px',
        whiteSpace: 'nowrap'
    },
    settlementButtonPrimary: {
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(230, 109, 51, 0.3)'
    },
    settlementButtonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementButtonExport: {
        background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
        color: 'white',
        boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
    },
    settlementTableWrapper: {
        borderRadius: '12px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '60vh',
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    },
    settlementTable: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1700px'
    },
    settlementTableHead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    settlementTableHeader: {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    settlementTableCell: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center',
        verticalAlign: 'middle'
    },
    settlementBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    settlementBadgePaid: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementBadgePending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    settlementBadgeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    settlementEmptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    settlementEmptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    settlementEmptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    settlementModalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)',
        padding: '20px'
    },
    settlementModal: {
        background: 'white',
        borderRadius: '16px',
        padding: '28px',
        width: '560px',
        maxWidth: '95%',
        maxHeight: '85vh',
        scrollbarWidth: 'none',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        animation: 'settlementSlideUp 0.3s ease'
    },
    settlementModalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: '16px',
        borderBottom: '2px solid #f0f0f0',
        marginBottom: '20px'
    },
    settlementModalTitle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1a1a2e',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    settlementModalClose: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#a0aec0',
        transition: 'all 0.3s ease',
        padding: '4px'
    },
    settlementModalBody: {
        padding: '0 0 4px 0'
    },
    settlementFormRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '16px'
    },
    settlementFormGroup: {
        marginBottom: '16px'
    },
    settlementFormGroupFull: {
        marginBottom: '16px',
        gridColumn: '1 / -1'
    },
    settlementLabel: {
        display: 'block',
        marginBottom: '6px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568'
    },
    settlementReadOnlyInput: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #edf2f7',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        background: '#f7fafc',
        cursor: 'not-allowed',
        boxSizing: 'border-box'
    },
    settlementTextarea: {
        width: '100%',
        padding: '10px 14px',
        borderRadius: '8px',
        border: '2px solid #e2e8f0',
        fontSize: '13px',
        outline: 'none',
        transition: 'all 0.3s ease',
        resize: 'vertical',
        boxSizing: 'border-box',
        fontFamily: 'inherit'
    },
    settlementModalFooter: {
        display: 'flex',
        gap: '10px',
        paddingTop: '16px',
        borderTop: '2px solid #f0f0f0',
        marginTop: '4px'
    },
    settlementAmount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    settlementRemarksCell: {
        maxWidth: '150px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        cursor: 'pointer',
        color: '#4a5568'
    },
    settlementPaymentMode: {
        display: 'inline-block',
        padding: '2px 10px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600'
    },
    settlementPaymentModeFT: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    settlementPaymentModeNEFT: {
        background: '#c6f6d5',
        color: '#276749'
    },
    settlementPaymentModeRTGS: {
        background: '#e9d8fd',
        color: '#553c9a'
    },
    settlementPaymentModeIMPS: {
        background: '#fefcbf',
        color: '#975a16'
    },
    settlementPaymentModeDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },

    // ============================================
    // VENDOR DASHBOARD CARD STYLES
    // ============================================
    vendorDashboardGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '20px',
        marginBottom: '20px'
    },
    vendorCard: {
        background: 'white',
        borderRadius: '16px',
        border: '1px solid #edf2f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    vendorCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        background: 'linear-gradient(135deg, #e66d33 0%, #e66d33 100%)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        flexWrap: 'wrap',
        gap: '12px'
    },
    vendorCardHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px'
    },
    vendorAvatar: {
        width: '48px',
        height: '48px',
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        color: 'white',
        backdropFilter: 'blur(10px)'
    },
    vendorHeaderInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    vendorHeaderName: {
        margin: 0,
        fontSize: '18px',
        fontWeight: '700',
        color: 'white'
    },
    vendorHeaderId: {
        fontSize: '12px',
        color: 'white',


    },
    vendorHeaderCity: {
        fontSize: '13px',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    vendorHeaderRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        flexWrap: 'wrap'
    },
    vendorHeaderStat: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 12px',
        borderRadius: '12px',
        background: 'rgba(255,255,255,0.15)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500'
    },
    vendorHeaderStatPaid: {
        background: 'white',
        color: '#ff6b6b'
    },
    vendorHeaderStatPending: {
        background: 'white',
        color: '#ff6b6b'
    },
    vendorHeaderStatRejected: {
        background: 'white',
        color: '#ff6b6b'
    },
    expandIcon: {
        color: 'white',
        fontSize: '20px',
        fontWeight: '700',
        marginLeft: '5px',
        transition: 'transform 0.3s ease'
    },
    expandIconRotated: {
        transform: 'rotate(180deg)'
    },

    // Vendor Dashboard Body
    vendorDashboardBody: {
        padding: '20px 24px 24px 24px',
        animation: 'slideDown 0.3s ease'
    },

    // KPI Cards Grid
    kpiGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
        gap: '14px',
        marginBottom: '20px'
    },
    kpiCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7',
        transition: 'all 0.3s ease'
    },
    kpiCardHover: {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    },
    kpiLabel: {
        fontSize: '11px',
        fontWeight: '600',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '6px'
    },
    kpiValue: {
        fontSize: '24px',
        fontWeight: '700',
        color: '#2d3748'
    },
    kpiSubtext: {
        fontSize: '12px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    kpiIcon: {
        fontSize: '20px',
        marginBottom: '4px'
    },

    // Vendor Details Section
    vendorDetailsGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '16px',
        marginBottom: '20px'
    },
    vendorDetailCard: {
        background: '#f8f9fa',
        borderRadius: '12px',
        padding: '16px',
        border: '1px solid #edf2f7'
    },
    vendorDetailTitle: {
        fontSize: '13px',
        fontWeight: '600',
        color: '#4a5568',
        marginBottom: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    vendorDetailRow: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '6px 0',
        borderBottom: '1px solid #e9ecef',
        fontSize: '13px'
    },
    vendorDetailRowLast: {
        borderBottom: 'none'
    },
    vendorDetailLabel: {
        color: '#718096'
    },
    vendorDetailValue: {
        fontWeight: '500',
        color: '#2d3748'
    },

    // Settlement Items Table inside Vendor Card
    vendorSettlementTable: {
        width: '100%',
        fontSize: '12px',
        borderCollapse: 'collapse',
        marginTop: '10px'
    },
    vendorSettlementHeader: {
        padding: '8px 5px',
        textAlign: 'center',
        fontWeight: '600',
        fontSize: '10px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: '#718096',
        borderBottom: '2px solid #edf2f7'
    },
    vendorSettlementCell: {
        padding: '8px 5px',
        textAlign: 'center',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '12px'
    },
    vendorSettlementAction: {
        padding: '4px 12px',
        borderRadius: '6px',
        border: 'none',
        fontWeight: '600',
        fontSize: '11px',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },

    // Date Filter Section
    dateFilterSection: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '12px 16px',
        background: '#f8f9fa',
        borderRadius: '10px',
        marginBottom: '16px',
        border: '1px solid #edf2f7'
    },
    dateFilterButton: {
        padding: '6px 16px',
        borderRadius: '20px',
        border: '2px solid #e2e8f0',
        background: 'white',
        fontSize: '12px',
        fontWeight: '500',
        color: '#4a5568',
        cursor: 'pointer',
        transition: 'all 0.3s ease'
    },
    dateFilterButtonActive: {
        borderColor: '#e66d33',
        background: '#e66d33',
        color: 'white'
    },
    dateFilterDivider: {
        color: '#e2e8f0',
        fontSize: '18px',
        fontWeight: '300'
    }
};

// ============================================
// VENDOR DASHBOARD CARD COMPONENT
// ============================================
const VendorDashboardCard = ({ vendorId, vendorData, onUpdateStatus }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedSettlement, setSelectedSettlement] = useState(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const [remarks, setRemarks] = useState('');
    const [pytMode, setPytMode] = useState('FT');

    const toggleExpand = () => setIsExpanded(!isExpanded);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount || 0);
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID") return styles.settlementBadgePaid;
        if (status === "PENDING") return styles.settlementBadgePending;
        return styles.settlementBadgeDefault;
    };

    const getPaymentModeStyle = (mode) => {
        switch (mode) {
            case "FT": return styles.settlementPaymentModeFT;
            case "NEFT": return styles.settlementPaymentModeNEFT;
            case "RTGS": return styles.settlementPaymentModeRTGS;
            case "IMPS": return styles.settlementPaymentModeIMPS;
            default: return styles.settlementPaymentModeDefault;
        }
    };

    // Calculate KPIs
    const totalSettlements = vendorData.length;
    const totalAmount = vendorData.reduce((sum, item) => sum + (item.finalAmount || 0), 0);
    const paidCount = vendorData.filter(item => item.paymentStatus === "PAID").length;
    const pendingCount = vendorData.filter(item => item.paymentStatus === "PENDING").length;
    const totalCash = vendorData.reduce((sum, item) => sum + (item.totalCash || 0), 0);
    const totalCommission = vendorData.reduce((sum, item) => sum + (item.commission || 0), 0);

    const handleStatusUpdateClick = (settlement) => {
        setSelectedSettlement(settlement);
        setNewStatus(settlement.paymentStatus);
        setRemarks(settlement.remarks || '');
        setPytMode(settlement.pytMode || 'FT');
        setShowUpdateModal(true);
    };

    const handleUpdateStatus = async () => {
        if (!selectedSettlement || !newStatus) {
            alert("Please select a status");
            return;
        }
        if (!remarks.trim()) {
            alert("Please enter remarks for the status update");
            return;
        }

        const settlementId = selectedSettlement.settlementId;
        const updateData = {
            settlementId: settlementId,
            vendorId: selectedSettlement.vendorId,
            totalCgst: selectedSettlement.totalCgst || 0,
            totalSgst: selectedSettlement.totalSgst || 0,
            totalGrandTotal: selectedSettlement.totalGrandTotal || 0,
            totalServiceCharges: selectedSettlement.totalServiceCharges || 0,
            totalPlatformCharges: selectedSettlement.totalPlatformCharges || 0,
            totalOnlinePayment: selectedSettlement.totalOnlinePayment || 0,
            totalAmountBeforeTds: selectedSettlement.totalAmountBeforeTds || 0,
            tdsAmount: selectedSettlement.tdsAmount || 0,
            amountAfterTds: selectedSettlement.amountAfterTds || 0,
            amountAfterCash: selectedSettlement.amountAfterCash || 0,
            finalAmount: selectedSettlement.finalAmount || 0,
            totalCash: selectedSettlement.totalCash || 0,
            description: selectedSettlement.description || "",
            fromDate: selectedSettlement.fromDate || new Date().toISOString(),
            toDate: selectedSettlement.toDate || new Date().toISOString(),
            totalVendorPlatformCharges: selectedSettlement.totalVendorPlatformCharges || 0,
            totalVendorPlatformChargesGst: selectedSettlement.totalVendorPlatformChargesGst || 0,
            holderName: selectedSettlement.holderName || "",
            restaurantName: selectedSettlement.restaurantName || "",
            accountNumber: selectedSettlement.accountNumber || "",
            ifscCode: selectedSettlement.ifscCode || "",
            settlementDate: selectedSettlement.settlementDate || new Date().toISOString().split("T")[0],
            paymentStatus: newStatus,
            superadminAccNo: selectedSettlement.superadminAccNo || "",
            pytMode: pytMode,
            remarks: remarks,
            totalWalletPayment: selectedSettlement.totalWalletPayment || 0,
            commission: selectedSettlement.commission || 0,
        };

        try {
            await updateSettlementStatusAPI(settlementId, updateData);
            alert("Status updated successfully!");
            onUpdateStatus();
            setShowUpdateModal(false);
            setSelectedSettlement(null);
            setNewStatus('');
            setRemarks('');
            setPytMode('FT');
        } catch (err) {
            console.error("Error updating status:", err);
            alert(`Failed to update status: ${err.response?.data?.message || err.message}`);
        }
    };

    return (
        <>
            <div style={styles.vendorCard}>
                {/* Vendor Card Header - Click to Expand */}
                <div style={styles.vendorCardHeader} onClick={toggleExpand}>
                    <div style={styles.vendorCardHeaderLeft}>
                        <div style={styles.vendorAvatar}>
                            {vendorData[0]?.vendorLogo || '🏪'}
                        </div>
                        <div style={styles.vendorHeaderInfo}>
                            <h3 style={styles.vendorHeaderName}>
                                {vendorData[0]?.restaurantName || vendorData[0]?.holderName}
                            </h3>

                            {/* <div style={styles.vendorHeaderCity}>
                                <Icons.Building /> {vendorData[0]?.city || 'N/A'}
                            </div> */}
                        </div>
                    </div>
                    <div style={styles.vendorHeaderRight}>
                        <span style={{ ...styles.vendorHeaderStat, ...styles.vendorHeaderStatPending }}>
                            <Icons.Clock /> {pendingCount} Pending
                        </span>
                        <span style={{ ...styles.vendorHeaderStat, ...styles.vendorHeaderStatPaid }}>
                            <Icons.CheckCircle /> {paidCount} Paid
                        </span>
                        <span style={{ ...styles.vendorHeaderStat }}>
                            <Icons.Money /> {formatCurrency(totalAmount)}
                        </span>
                        <span style={{
                            ...styles.expandIcon,
                            ...(isExpanded ? styles.expandIconRotated : {})
                        }}>
                            ▼
                        </span>
                    </div>
                </div>

                {/* Expanded Content - Vendor Dashboard */}
                {isExpanded && (
                    <div style={styles.vendorDashboardBody}>
                        {/* KPI Cards Grid */}
                        <div style={styles.kpiGrid}>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>📊</div>
                                <div style={styles.kpiLabel}>Total Settlements</div>
                                <div style={styles.kpiValue}>{totalSettlements}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>💰</div>
                                <div style={styles.kpiLabel}>Total Amount</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalAmount)}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>✅</div>
                                <div style={styles.kpiLabel}>Paid</div>
                                <div style={styles.kpiValue}>{paidCount}</div>
                                <div style={styles.kpiSubtext}>{formatCurrency(totalAmount * (paidCount / (totalSettlements || 1)))}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>⏳</div>
                                <div style={styles.kpiLabel}>Pending</div>
                                <div style={styles.kpiValue}>{pendingCount}</div>
                                <div style={styles.kpiSubtext}>{formatCurrency(totalAmount * (pendingCount / (totalSettlements || 1)))}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>💳</div>
                                <div style={styles.kpiLabel}>Total Cash</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalCash)}</div>
                            </div>
                            <div style={styles.kpiCard}>
                                <div style={styles.kpiIcon}>📈</div>
                                <div style={styles.kpiLabel}>Commission</div>
                                <div style={styles.kpiValue}>{formatCurrency(totalCommission)}</div>
                            </div>
                        </div>

                        {/* Vendor Details */}
                        <div style={styles.vendorDetailsGrid}>
                            <div style={styles.vendorDetailCard}>
                                <div style={styles.vendorDetailTitle}>
                                    <Icons.User /> Bank Details
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Account Holder</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.holderName || '-'}</span>
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Account Number</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.accountNumber || '-'}</span>
                                </div>
                                <div style={{ ...styles.vendorDetailRow, ...styles.vendorDetailRowLast }}>
                                    <span style={styles.vendorDetailLabel}>IFSC Code</span>
                                    <span style={styles.vendorDetailValue}>{vendorData[0]?.ifscCode || '-'}</span>
                                </div>
                            </div>
                            <div style={styles.vendorDetailCard}>
                                <div style={styles.vendorDetailTitle}>
                                    <Icons.Wallet /> Summary
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Admin Account</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData[0]?.superadminAccNo || '-')}</span>
                                </div>
                                <div style={styles.vendorDetailRow}>
                                    <span style={styles.vendorDetailLabel}>Total Sales</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData.reduce((sum, item) => sum + (item.totalAmountBeforeTds || 0), 0))}</span>
                                </div>
                                <div style={{ ...styles.vendorDetailRow, ...styles.vendorDetailRowLast }}>
                                    <span style={styles.vendorDetailLabel}>Service Charges</span>
                                    <span style={styles.vendorDetailValue}>{formatCurrency(vendorData.reduce((sum, item) => sum + (item.tdsAmount || 0), 0))}</span>
                                </div>
                            </div>
                        </div>

                        {/* Settlement Items Table */}
                        {/* <div style={{ ...styles.vendorDetailCard, padding: '0', background: 'white' }}>
                            <div style={{ ...styles.vendorDetailTitle, padding: '16px 16px 0 16px' }}>
                                <Icons.Settlement /> Settlement History
                            </div>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={styles.vendorSettlementTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.vendorSettlementHeader}>#</th>
                                            <th style={styles.vendorSettlementHeader}>Settlement ID</th>
                                            <th style={styles.vendorSettlementHeader}>From</th>
                                            <th style={styles.vendorSettlementHeader}>To</th>
                                            <th style={styles.vendorSettlementHeader}>Amount</th>
                                            <th style={styles.vendorSettlementHeader}>Cash</th>
                                            <th style={styles.vendorSettlementHeader}>Mode</th>
                                            <th style={styles.vendorSettlementHeader}>Status</th>
                                            <th style={styles.vendorSettlementHeader}>Remarks</th>
                                            <th style={styles.vendorSettlementHeader}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendorData.map((item, index) => (
                                            <tr key={item.settlementId || index}>
                                                <td style={styles.vendorSettlementCell}>{index + 1}</td>
                                                <td style={{ ...styles.vendorSettlementCell, fontFamily: 'monospace', fontSize: '11px' }}>
                                                    {item.settlementId}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.fromDate
                                                        ? new Date(item.fromDate).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                        : "N/A"}
                                                </td>

                                                <td style={styles.vendorSettlementCell}>
                                                    {item.toDate
                                                        ? new Date(item.toDate).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                        : "N/A"}
                                                </td>
                                                <td style={{ ...styles.vendorSettlementCell, fontWeight: '600', color: '#0b5e42' }}>
                                                    {formatCurrency(item.finalAmount)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>{formatCurrency(item.totalCash)}</td>
                                                <td style={styles.vendorSettlementCell}>
                                                    <span style={{ ...styles.settlementPaymentMode, ...getPaymentModeStyle(item.pytMode) }}>
                                                        {item.pytMode || "FT"}
                                                    </span>
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    <span style={{ ...styles.settlementBadge, ...getStatusBadge(item.paymentStatus) }}>
                                                        {item.paymentStatus}
                                                    </span>
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.remarks ? (
                                                        <div style={styles.settlementRemarksCell} title={item.remarks}>
                                                            {item.remarks}
                                                        </div>
                                                    ) : "-"}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.paymentStatus !== "PAID" ? (
                                                        <button
                                                            onClick={() => handleStatusUpdateClick(item)}
                                                            style={{
                                                                ...styles.vendorSettlementAction,
                                                                background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                                                color: 'white'
                                                            }}
                                                        >
                                                            Update
                                                        </button>
                                                    ) : (
                                                        <span style={{ color: '#48bb78', fontWeight: '600', fontSize: '11px' }}>
                                                            ✓ Completed
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div> */}
                        {/* Settlement Items Table */}
                        <div style={{ ...styles.vendorDetailCard, padding: '0', background: 'white' }}>
                            <div style={{ ...styles.vendorDetailTitle, padding: '16px 16px 0 16px' }}>
                                <Icons.Settlement /> Settlement History
                            </div>
                            <div style={{ overflowX: 'auto', maxHeight: "300px", scrollbarWidth: "thin" }}>
                                <table style={styles.vendorSettlementTable}>
                                    <thead>
                                        <tr>
                                            <th style={styles.vendorSettlementHeader}>#</th>
                                            {/* <th style={styles.vendorSettlementHeader}>Settlement ID</th> */}
                                            <th style={styles.vendorSettlementHeader}>Date</th>
                                            <th style={styles.vendorSettlementHeader}>Total Amount</th>
                                            <th style={styles.vendorSettlementHeader}>Total Cash</th>
                                            <th style={styles.vendorSettlementHeader}>Online</th>
                                            <th style={styles.vendorSettlementHeader}>Wallet</th>
                                            <th style={styles.vendorSettlementHeader}>GST</th>
                                            <th style={styles.vendorSettlementHeader}>TDS</th>
                                            <th style={styles.vendorSettlementHeader}>Service Charges</th>
                                            <th style={styles.vendorSettlementHeader}>Platform Charges</th>
                                            <th style={styles.vendorSettlementHeader}>Delivery Charges</th>
                                            <th style={styles.vendorSettlementHeader}>Payment Gateway Charges</th>
                                            <th style={styles.vendorSettlementHeader}>Vendor Credits</th>

                                            <th style={styles.vendorSettlementHeader}>Final Amount</th>
                                            <th style={styles.vendorSettlementHeader}>Status</th>
                                            <th style={styles.vendorSettlementHeader}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendorData.map((item, index) => (
                                            <tr key={item.settlementId || index}>
                                                <td style={styles.vendorSettlementCell}>{index + 1}</td>
                                                {/* <td style={{ ...styles.vendorSettlementCell, fontFamily: 'monospace', fontSize: '11px' }}>
                                                    {item.settlementId}
                                                </td> */}
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.settlementDate
                                                        ? new Date(item.settlementDate).toLocaleDateString("en-GB").replace(/\//g, "-")
                                                        : "N/A"}
                                                </td>
                                                <td style={{ ...styles.vendorSettlementCell, fontWeight: '600', color: '#0b5e42' }}>
                                                    ₹{Number(item.totalGrandTotal || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalCash || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalOnlinePayment || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalWalletPayment || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number((item.totalCgst || 0) + (item.totalSgst || 0)).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.tdsAmount || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalServiceCharges || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalPlatformCharges || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.totalDeliveryCharges || 0).toFixed(2)}
                                                </td>
                                                <td style={{ ...styles.vendorSettlementCell }}>
                                                    ₹{Number(item.paymentGatewayCharges || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    ₹{Number(item.vendorCreditsUsed || 0).toFixed(2)}
                                                </td>

                                                <td style={{ ...styles.vendorSettlementCell, fontWeight: '700', color: '#e66d33' }}>
                                                    ₹{Number(item.finalAmount || 0).toFixed(2)}
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    <span style={{ ...styles.settlementBadge, ...getStatusBadge(item.paymentStatus) }}>
                                                        {item.paymentStatus}
                                                    </span>
                                                </td>
                                                <td style={styles.vendorSettlementCell}>
                                                    {item.paymentStatus !== "PAID" ? (
                                                        <button
                                                            onClick={() => handleStatusUpdateClick(item)}
                                                            style={{
                                                                ...styles.vendorSettlementAction,
                                                                background: 'linear-gradient(135deg, #e66d33 0%, #d45a2a 100%)',
                                                                color: 'white'
                                                            }}
                                                        >
                                                            Update
                                                        </button>
                                                    ) : (
                                                        <span style={{ color: '#48bb78', fontWeight: '600', fontSize: '11px' }}>
                                                            ✓ Completed
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* Update Status Modal */}
            {showUpdateModal && selectedSettlement && (
                <div style={styles.settlementModalOverlay} onClick={() => setShowUpdateModal(false)}>
                    <div style={styles.settlementModal} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.settlementModalHeader}>
                            <h3 style={styles.settlementModalTitle}>
                                <Icons.Edit style={{ color: '#e66d33' }} /> Update Status
                            </h3>
                            <button style={styles.settlementModalClose} onClick={() => setShowUpdateModal(false)}>
                                <Icons.Close />
                            </button>
                        </div>

                        <div style={styles.settlementModalBody}>
                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Settlement ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.settlementId}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Vendor ID</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.vendorId}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Vendor Name</label>
                                    <input
                                        type="text"
                                        value={selectedSettlement.holderName || "-"}
                                        readOnly
                                        style={styles.settlementReadOnlyInput}
                                    />
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Current Status</label>
                                    <div style={{
                                        ...styles.settlementBadge,
                                        ...getStatusBadge(selectedSettlement.paymentStatus),
                                        fontSize: '14px',
                                        padding: '10px 16px',
                                        display: 'inline-block',
                                        width: '100%',
                                        textAlign: 'center',
                                        boxSizing: 'border-box'
                                    }}>
                                        {selectedSettlement.paymentStatus}
                                    </div>
                                </div>
                            </div>

                            <div style={styles.settlementFormRow}>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>Payment Mode</label>
                                    <select
                                        value={pytMode}
                                        onChange={(e) => setPytMode(e.target.value)}
                                        style={styles.settlementSelect}
                                    >
                                        <option value="FT">FT (Fund Transfer)</option>
                                        <option value="NEFT">NEFT</option>
                                        <option value="RTGS">RTGS</option>
                                        <option value="IMPS">IMPS</option>
                                    </select>
                                </div>
                                <div style={styles.settlementFormGroup}>
                                    <label style={styles.settlementLabel}>New Status *</label>
                                    <select
                                        value={newStatus}
                                        onChange={(e) => setNewStatus(e.target.value)}
                                        style={styles.settlementSelect}
                                        required
                                    >
                                        <option value="">Select Status</option>
                                        <option value="PENDING">PENDING</option>
                                        <option value="PAID">PAID</option>
                                    </select>
                                </div>
                            </div>

                            <div style={styles.settlementFormGroupFull}>
                                <label style={styles.settlementLabel}>Remarks *</label>
                                <textarea
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder="Enter remarks for status update (required)"
                                    rows="3"
                                    style={styles.settlementTextarea}
                                    onFocus={(e) => {
                                        e.target.style.borderColor = '#e66d33';
                                        e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderColor = '#e2e8f0';
                                        e.target.style.boxShadow = 'none';
                                    }}
                                    required
                                />
                                <small style={{ color: '#718096', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                                    Please provide a reason for the status change
                                </small>
                            </div>

                            <div style={styles.settlementModalFooter}>
                                <button
                                    onClick={() => setShowUpdateModal(false)}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary, flex: 1 }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleUpdateStatus}
                                    style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary, flex: 1 }}
                                >
                                    Update Status
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// ============================================
// MAIN COMPONENT - Foodsettlementpage
// ============================================
const Foodsettlementpage = () => {
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [dateFilterType, setDateFilterType] = useState("all");
    const [customStartDate, setCustomStartDate] = useState("");
    const [customEndDate, setCustomEndDate] = useState("");
    const [showDateDropdown, setShowDateDropdown] = useState(false);

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "holderName", label: "Vendor Name" },
        { value: "restaurantName", label: "Restaurant Name" },
        { value: "accountNumber", label: "Account Number" },
        { value: "ifscCode", label: "IFSC Code" }
    ];

    const [settlements, setSettlements] = useState([]);
    const [vendorGroups, setVendorGroups] = useState({});
    const [filteredVendorGroups, setFilteredVendorGroups] = useState({});
    const [profitsData, setProfitsData] = useState(null);

    const { showLoader, hideLoader } = useLoader();

    useEffect(() => {
        fetchSettlements();
    }, []);

    // Helper: compute fromDate & toDate from the current filter type
    const getDateRangeFromFilter = () => {
        const now = new Date();
        const fmt = (d) => d.toISOString().split('T')[0]; // yyyy-mm-dd

        switch (dateFilterType) {
            case 'today':
                return { fromDate: fmt(now), toDate: fmt(now) };
            case 'yesterday': {
                const y = new Date(now);
                y.setDate(y.getDate() - 1);
                return { fromDate: fmt(y), toDate: fmt(y) };
            }
            case 'week': {
                const start = new Date(now);
                start.setDate(now.getDate() - 6);
                return { fromDate: fmt(start), toDate: fmt(now) };
            }
            case 'month': {
                const start = new Date(now.getFullYear(), now.getMonth(), 1);
                const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                return { fromDate: fmt(start), toDate: fmt(end) };
            }
            case 'lastMonth': {
                const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                const end = new Date(now.getFullYear(), now.getMonth(), 0);
                return { fromDate: fmt(start), toDate: fmt(end) };
            }
            case 'custom':
                if (customStartDate && customEndDate) {
                    return { fromDate: customStartDate, toDate: customEndDate };
                }
                return null;
            default: {
                // 'all' — default to current month
                const start = new Date(now.getFullYear(), now.getMonth(), 1);
                const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                return { fromDate: fmt(start), toDate: fmt(end) };
            }
        }
    };

    const fetchProfits = async () => {
        const range = getDateRangeFromFilter();
        if (!range) return;
        try {
            const data = await getSettlementProfitsAPI(range.fromDate, range.toDate);
            setProfitsData(data);
        } catch (err) {
            console.error('Error fetching profits:', err);
        }
    };

    // Re-fetch profits whenever the date filter changes
    useEffect(() => {
        fetchProfits();
    }, [dateFilterType, customStartDate, customEndDate]);

    const fetchSettlements = async () => {
        try {
            showLoader();
            const res = await getAllSettlementsAPI();
            const data = res.settlements || res;
            const dataWithSno = Array.isArray(data)
                ? data.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                }))
                : [];
            setSettlements(dataWithSno);
            groupByVendor(dataWithSno);
        } catch (err) {
            console.error("Error fetching settlements:", err);
        } finally {
            hideLoader();
        }
    };

    const groupByVendor = (data) => {
        const grouped = data.reduce((acc, item) => {
            const vendorId = item.vendorId;
            if (!acc[vendorId]) {
                acc[vendorId] = [];
            }
            acc[vendorId].push(item);
            return acc;
        }, {});
        setVendorGroups(grouped);
        setFilteredVendorGroups(grouped);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "holderName": return "Search by Vendor Name...";
            case "accountNumber": return "Search by Account Number...";
            case "ifscCode": return "Search by IFSC Code...";
            default: return "Search...";
        }
    };

    // Date filter logic
    const applyDateFilter = (data) => {
        if (dateFilterType === "all") return data;

        const now = new Date();
        let startDate = new Date();
        let endDate = new Date();

        switch (dateFilterType) {
            case "today":
                startDate = new Date(now.setHours(0, 0, 0, 0));
                endDate = new Date(now.setHours(23, 59, 59, 999));
                break;
            case "yesterday":
                startDate = new Date(now);
                startDate.setDate(startDate.getDate() - 1);
                startDate.setHours(0, 0, 0, 0);
                endDate = new Date(startDate);
                endDate.setHours(23, 59, 59, 999);
                break;
            case "week":
                const day = now.getDay();
                startDate = new Date(now);
                startDate.setDate(now.getDate() - day);
                startDate.setHours(0, 0, 0, 0);
                endDate = new Date(now);
                endDate.setDate(now.getDate() + (6 - day));
                endDate.setHours(23, 59, 59, 999);
                break;
            case "month":
                startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case "lastMonth":
                startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                endDate = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999);
                break;
            case "custom":
                if (customStartDate && customEndDate) {
                    startDate = new Date(customStartDate);
                    endDate = new Date(customEndDate);
                    endDate.setHours(23, 59, 59, 999);
                } else {
                    return data;
                }
                break;
            default:
                return data;
        }

        return data.filter(item => {
            const settlementDate = new Date(item.settlementDate || item.fromDate);
            return settlementDate >= startDate && settlementDate <= endDate;
        });
    };

    const applyFilters = useMemo(() => {
        let filtered = { ...vendorGroups };

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => {
                    const fieldValue = item[searchType];
                    return fieldValue && fieldValue.toString().toLowerCase().includes(query);
                });
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Status filter
        if (selectedStatusFilter) {
            const filteredKeys = Object.keys(filtered).filter(vendorId => {
                const items = filtered[vendorId];
                return items.some(item => item.paymentStatus === selectedStatusFilter);
            });
            filtered = Object.fromEntries(
                Object.entries(filtered).filter(([key]) => filteredKeys.includes(key))
            );
        }

        // Date filter
        const dateFiltered = Object.fromEntries(
            Object.entries(filtered).map(([vendorId, items]) => {
                const filteredItems = applyDateFilter(items);
                return [vendorId, filteredItems];
            }).filter(([_, items]) => items.length > 0)
        );

        return dateFiltered;
    }, [vendorGroups, searchQuery, searchType, selectedStatusFilter, dateFilterType, customStartDate, customEndDate]);

    useEffect(() => {
        setFilteredVendorGroups(applyFilters);
    }, [applyFilters]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setSelectedStatusFilter("");
        setDateFilterType("all");
        setCustomStartDate("");
        setCustomEndDate("");
    };

    const uniqueStatuses = useMemo(() => {
        const statuses = settlements.map(item => item.paymentStatus).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [settlements]);

    const handleExport = () => {
        const allItems = Object.values(vendorGroups).flat();
        if (allItems.length === 0) {
            alert("There is no data to export.");
            return;
        }

        const escapeCsvField = (field) => {
            const str = String(field ?? '');
            if (str.includes(',') || str.includes('"') || str.includes('\n')) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };

        const headers = [
            "S.NO", "Vendor ID", "Vendor Name", "Restaurant Name", "Total Sales", "Service Charges",
            "Commission Charges", "To Settle", "Total Cash", "From Date", "To Date",
            "Admin Account", "Vendor Account", "IFSC Code", "Settlement Date",
            "Status", "Payment Mode", "Remarks"
        ];

        const csvRows = allItems.map((item) => [
            item.sno || '',
            item.vendorId || '',
            item.holderName || '',
            item.restaurantName || "",
            item.totalAmountBeforeTds || 0,
            item.tdsAmount || 0,
            item.commission || 0,
            item.finalAmount || 0,
            item.totalCash || 0,
            formatDate(item.fromDate),
            formatDate(item.toDate),
            item.superadminAccNo || '',
            item.accountNumber || '',
            item.ifscCode || '',
            item.settlementDate || '',
            item.paymentStatus || '',
            item.pytMode || 'FT',
            item.remarks || ''
        ]);

        const csvString = [
            headers.map(escapeCsvField).join(','),
            ...csvRows.map(row => row.map(escapeCsvField).join(','))
        ].join('\r\n');

        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `settlements_${new Date().toISOString().split('T')[0]}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        const date = new Date(dateString);
        return date.toISOString().split("T")[0];
    };

    const getStatusBadge = (status) => {
        if (!status) return styles.settlementBadgeDefault;
        if (status === "PAID") return styles.settlementBadgePaid;
        if (status === "PENDING") return styles.settlementBadgePending;
        return styles.settlementBadgeDefault;
    };

    // Calculate overall stats
    const allItems = Object.values(vendorGroups).flat();
    const totalSettlements = allItems.length;
    const totalAmount = allItems.reduce((sum, item) => sum + (item.finalAmount || 0), 0);
    const paidCount = allItems.filter(item => item.paymentStatus === "PAID").length;
    const pendingCount = allItems.filter(item => item.paymentStatus === "PENDING").length;
    const totalVendors = Object.keys(vendorGroups).length;

    return (
        <div className="settlement-wrapper" style={styles.settlementContainer}>
            {/* Header */}
            {/* <div style={styles.settlementHeader}>
                <h2 style={styles.settlementTitle}>
                    <Icons.Settlement /> Vendor Settlements Dashboard
                    <span style={styles.settlementTitleBadge}>
                        {totalVendors} Vendors
                    </span>
                </h2>
                <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div> */}

            {/* Profits Stats Row */}
            {profitsData && (
                <div style={{ ...styles.settlementStatsGrid, gridTemplateColumns: 'repeat(5, 1fr)', marginBottom:"10px" }}>
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#e66d33', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalPlatformCharges + profitsData.totalPlatformChargesGst + profitsData.totalVendorPlatformCharges + profitsData.totalVendorPlatformChargesGst || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Total Profits</div>
                    </div>
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#e53e3e', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalPlatformCharges || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Platform Charges</div>
                    </div>
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#805ad5', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalPlatformChargesGst || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Platform Charges GST</div>
                    </div>
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#d69e2e', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalVendorPlatformCharges || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Vendor Platform Charges</div>
                    </div>
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#3182ce', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalVendorPlatformChargesGst || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Vendor Platform Charges</div>
                    </div>
                    {/* <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#28a745', fontSize: '16px' }}>
                            ₹{Number(profitsData.totalVendorSettlements || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Vendor Settlements</div>
                    </div> */}
                </div>
            )}

            {/* Stats Grid */}
            <div style={styles.settlementStatsGrid}>

                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalVendors}</div>
                    <div style={styles.settlementStatLabel}>Total Vendors</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={styles.settlementStatValue}>{totalSettlements}</div>
                    <div style={styles.settlementStatLabel}>Total Settlements</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        ₹{Number(totalAmount).toFixed(2)}
                    </div>
                    <div style={styles.settlementStatLabel}>Total Amount</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#28a745' }}>
                        {paidCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Paid</div>
                </div>
                <div style={styles.settlementStatCard}>
                    <div style={{ ...styles.settlementStatValue, color: '#ffc107' }}>
                        {pendingCount}
                    </div>
                    <div style={styles.settlementStatLabel}>Pending</div>
                </div>
                {/* {profitsData && (
                    <div style={styles.settlementStatCard}>
                        <div style={{ ...styles.settlementStatValue, color: '#e66d33' }}>
                            ₹{Number(profitsData.totalPlatformCharges + profitsData.totalPlatformChargesGst + profitsData.totalVendorPlatformCharges + profitsData.totalVendorPlatformChargesGst || 0).toFixed(2)}
                        </div>
                        <div style={styles.settlementStatLabel}>Total Profits</div>
                    </div>
                )} */}
            </div>




            {/* Filters */}
            <div style={styles.settlementFilters}>
                <div style={styles.settlementSearchGroup}>
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.settlementSelect}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <div style={{ position: 'relative', flex: 1 }}>
                        <input
                            type="text"
                            placeholder={getPlaceholderText()}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            style={{
                                ...styles.settlementSearchInput,
                                borderColor: searchQuery ? '#e66d33' : '#e2e8f0'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#e66d33';
                                e.target.style.boxShadow = '0 0 0 3px rgba(230, 109, 51, 0.1)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                </div>



                <select
                    value={selectedStatusFilter}
                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    style={{ ...styles.settlementSelect, minWidth: '130px' }}
                >
                    <option value="">All Status</option>
                    {uniqueStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>


                {/* Date Filter Dropdown - beside Clear */}
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <button
                        onClick={() => {
                            if (dateFilterType === 'custom') {
                                setDateFilterType('all');
                            }
                            setShowDateDropdown(!showDateDropdown);
                        }}
                        style={{
                            padding: '8px 18px',
                            borderRadius: '8px',
                            border: '1.5px solid #e0e0e0',
                            background: '#fff',
                            fontSize: '13px',
                            fontWeight: 600,
                            color: '#2d3436',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {{ all: 'All Time', today: 'Today', yesterday: 'Yesterday', week: 'This Week', month: 'This Month', lastMonth: 'Last Month', custom: 'Custom Range' }[dateFilterType] || 'All Time'}
                        <span style={{ fontSize: '9px', color: '#636e72' }}>▼</span>
                    </button>

                    {showDateDropdown && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 'calc(100% + 6px)',
                                right: 0,
                                background: '#fff',
                                borderRadius: '12px',
                                boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
                                zIndex: 100,
                                minWidth: '210px',
                                overflow: 'hidden',
                            }}
                        >
                            {dateFilterType === 'custom' ? (
                                /* Custom Range: show ONLY date pickers */
                                <div style={{ padding: '18px 20px' }}>
                                    <div style={{ marginBottom: '14px' }}>
                                        <label style={{ display: 'block', fontSize: '13px', color: '#636e72', marginBottom: '6px' }}>From Date</label>
                                        <input
                                            type="date"
                                            value={customStartDate}
                                            onChange={(e) => setCustomStartDate(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '9px 12px',
                                                borderRadius: '8px',
                                                border: '1.5px solid #e0e0e0',
                                                fontSize: '13px',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#e66d33'}
                                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        />
                                    </div>
                                    <div style={{ marginBottom: '16px' }}>
                                        <label style={{ display: 'block', fontSize: '13px', color: '#636e72', marginBottom: '6px' }}>To Date</label>
                                        <input
                                            type="date"
                                            value={customEndDate}
                                            onChange={(e) => setCustomEndDate(e.target.value)}
                                            style={{
                                                width: '100%',
                                                padding: '9px 12px',
                                                borderRadius: '8px',
                                                border: '1.5px solid #e0e0e0',
                                                fontSize: '13px',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                            }}
                                            onFocus={(e) => e.target.style.borderColor = '#e66d33'}
                                            onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                                        />
                                    </div>
                                    <button
                                        onClick={() => setShowDateDropdown(false)}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            border: 'none',
                                            background: '#e66d33',
                                            color: '#fff',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Apply
                                    </button>
                                </div>
                            ) : (
                                /* Normal options list */
                                <>
                                    {[
                                        { value: 'today', label: 'Today' },
                                        { value: 'yesterday', label: 'Yesterday' },
                                        { value: 'week', label: 'This Week' },
                                        { value: 'month', label: 'This Month' },
                                        { value: 'lastMonth', label: 'Last Month' },
                                        { value: 'custom', label: 'Custom Range' },
                                    ].map((opt) => (
                                        <div
                                            key={opt.value}
                                            onClick={() => {
                                                setDateFilterType(opt.value);
                                                if (opt.value !== 'custom') setShowDateDropdown(false);
                                            }}
                                            style={{
                                                padding: '12px 20px',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                color: dateFilterType === opt.value ? '#e66d33' : '#2d3436',
                                                fontWeight: dateFilterType === opt.value ? 600 : 400,
                                                backgroundColor: dateFilterType === opt.value ? '#fff5f0' : '#fff',
                                                transition: 'background 0.15s',
                                            }}
                                            onMouseEnter={(e) => {
                                                if (dateFilterType !== opt.value) e.currentTarget.style.backgroundColor = '#f8f9fa';
                                            }}
                                            onMouseLeave={(e) => {
                                                if (dateFilterType !== opt.value) e.currentTarget.style.backgroundColor = '#fff';
                                            }}
                                        >
                                            {opt.label}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    )}

                    {/* Click-outside overlay */}
                    {showDateDropdown && (
                        <div
                            style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 99 }}
                            onClick={() => setShowDateDropdown(false)}
                        />
                    )}
                </div>

                <button onClick={clearAllFilters} style={{ ...styles.settlementButton, ...styles.settlementButtonSecondary }}>
                    <Icons.Clear /> Clear
                </button>
                <button onClick={fetchSettlements} style={{ ...styles.settlementButton, ...styles.settlementButtonPrimary }}>
                    <Icons.Refresh /> Refresh
                </button>
                <button onClick={handleExport} style={{ ...styles.settlementButton, ...styles.settlementButtonExport }}>
                    <Icons.Export /> Export All
                </button>
            </div>

            {/* Vendor Dashboard Cards */}
            {Object.keys(filteredVendorGroups).length > 0 ? (
                <div style={styles.vendorDashboardGrid}>
                    {Object.entries(filteredVendorGroups).map(([vendorId, vendorData]) => (
                        <VendorDashboardCard
                            key={vendorId}
                            vendorId={vendorId}
                            vendorData={vendorData}
                            onUpdateStatus={fetchSettlements}
                        />
                    ))}
                </div>
            ) : (
                <div style={styles.settlementEmptyState}>
                    <Icons.NoData />
                    <div style={styles.settlementEmptyStateText}>
                        {settlements.length === 0 ? 'Loading settlements...' : 'No vendors found'}
                    </div>
                    <div style={styles.settlementEmptyStateSubtext}>
                        {settlements.length === 0
                            ? 'Please wait while we fetch the data'
                            : (searchQuery.trim() || selectedStatusFilter || dateFilterType !== 'all')
                                ? 'Try adjusting your filters to see more results'
                                : 'No settlements are available'}
                    </div>
                </div>
            )}

            <style>{`
                @keyframes settlementSlideUp {
                    from { opacity: 0; transform: translateY(30px) scale(0.95); }
                    to { opacity: 1; transform: translateY(0) scale(1); }
                }

                @keyframes settlementFadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                @keyframes slideDown {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .settlement-wrapper {
                    animation: settlementFadeIn 0.4s ease;
                }

                /* Hover effects */
                .vendor-card-header:hover {
                    filter: brightness(1.05);
                }

                .kpi-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }

                /* Scroll styles */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #e66d33 0%, #d45a2a 100%);
                    border-radius: 4px;
                }
                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #d45a2a 0%, #b84a1a 100%);
                }

                /* Mobile Responsive */
                @media (max-width: 1024px) {
                    .settlement-container {
                        max-width: 95% !important;
                        padding: 10px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)) !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                }

                @media (max-width: 768px) {
                    .settlement-container {
                        max-width: 100% !important;
                        padding: 8px !important;
                    }
                    .settlement-filters {
                        flex-direction: column !important;
                        align-items: stretch !important;
                    }
                    .settlement-search-group {
                        min-width: unset !important;
                        flex-direction: column !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(3, 1fr) !important;
                        gap: 8px !important;
                        padding: 12px !important;
                    }
                    .settlement-stat-value {
                        font-size: 18px !important;
                    }
                    .settlement-stat-label {
                        font-size: 10px !important;
                    }
                    .vendor-card-header {
                        padding: 12px 16px !important;
                    }
                    .vendor-header-name {
                        font-size: 15px !important;
                    }
                    .vendor-dashboard-body {
                        padding: 12px !important;
                    }
                    .kpi-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                        gap: 8px !important;
                    }
                    .kpi-value {
                        font-size: 18px !important;
                    }
                    .vendor-details-grid {
                        grid-template-columns: 1fr !important;
                    }
                    .date-filter-section {
                        flex-wrap: wrap !important;
                        gap: 6px !important;
                        padding: 10px !important;
                    }
                    .date-filter-button {
                        font-size: 10px !important;
                        padding: 4px 10px !important;
                    }
                    .settlement-modal {
                        width: 98% !important;
                        padding: 16px !important;
                    }
                    .settlement-form-row {
                        grid-template-columns: 1fr !important;
                        gap: 10px !important;
                    }
                    .settlement-table {
                        font-size: 10px !important;
                        min-width: 800px !important;
                    }
                    .settlement-table th,
                    .settlement-table td {
                        padding: 4px 6px !important;
                        font-size: 9px !important;
                    }
                    .vendor-settlement-table {
                        font-size: 10px !important;
                    }
                    .vendor-settlement-cell {
                        padding: 4px 6px !important;
                        font-size: 10px !important;
                    }
                    .vendor-settlement-header {
                        font-size: 8px !important;
                        padding: 4px 6px !important;
                    }
                    .settlement-badge {
                        font-size: 8px !important;
                        padding: 2px 6px !important;
                    }
                }

                @media (max-width: 480px) {
                    .settlement-container {
                        padding: 4px !important;
                    }
                    .settlement-stats-grid {
                        grid-template-columns: repeat(2, 1fr) !important;
                    }
                    .kpi-grid {
                        grid-template-columns: 1fr 1fr !important;
                    }
                    .settlement-header {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                    }
                    .vendor-header-right {
                        width: 100% !important;
                        justify-content: flex-start !important;
                    }
                    .vendor-header-stat {
                        font-size: 10px !important;
                        padding: 2px 8px !important;
                    }
                    .settlement-modal {
                        padding: 12px !important;
                    }
                    .settlement-modal-title {
                        font-size: 16px !important;
                    }
                    .vendor-avatar {
                        width: 36px !important;
                        height: 36px !important;
                        font-size: 18px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default Foodsettlementpage;